import React from 'react';
import { Link } from 'react-router-dom';
import { Search, Target, Handshake, Briefcase, Globe, Gift, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  search: Search,
  target: Target,
  handshake: Handshake,
  briefcase: Briefcase,
  globe: Globe,
  gift: Gift
};

const ServicesSection = ({ data }) => {
  const services = data?.services || [];
  const { language } = useLanguage();
  
  // Show only first 3 services as preview on homepage
  const previewServices = services.slice(0, 3);
  
  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-display font-light text-brand-text mb-6">
            {data?.title || "Nossos Serviços"}
          </h2>
          <p className="text-lg font-body text-brand-text-secondary max-w-2xl mx-auto">
            {data?.subtitle || "Muito mais do que apenas uma agência imobiliária"}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-8 max-w-7xl mx-auto">
          {previewServices.map((service) => {
            const Icon = iconMap[service.icon] || Briefcase;
            return (
              <div key={service.id} className="group bg-brand-soft p-6 md:p-8 hover:shadow-lg transition-all duration-300 border border-transparent hover:border-brand-accent-hover text-center">
                <div className="mb-6 flex justify-center">
                  <div className="w-16 h-16 rounded-full bg-brand-primary flex items-center justify-center group-hover:bg-brand-primary-hover transition-colors duration-300">
                    <Icon className="w-8 h-8 text-brand-accent" />
                  </div>
                </div>
                <h3 className="text-lg md:text-xl font-display font-medium text-brand-text mb-4 hyphens-none">{service.title}</h3>
                <p className="text-brand-text-secondary font-body leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>

        {/* Botão Saiba Mais */}
        <div className="text-center mt-12">
          <Link 
            to="/servicos"
            className="inline-flex items-center gap-2 text-brand-primary hover:text-brand-primary-hover font-body font-medium text-lg transition-colors group"
          >
            {language === 'en' ? 'See All Services' : 'Ver Todos os Serviços'}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;